import SelectOutlinedUI from './SelectOutlinedUI'
import { SelectOutlinedUIStyled, SelectStyled } from './styles'

export { SelectOutlinedUIStyled, SelectStyled }
export default SelectOutlinedUI
